<template>
  <div class="container">
    <div class="background-container">
      <div v-for="(image, index) in backgroundImages" :key="index" class="image-wrapper">
        <el-image :src="image" class="background-image" fit="contain"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backgroundImages: [
        require('@/assets/images/mic1.jpg'),
        require('@/assets/images/mic2.jpg'),
        require('@/assets/images/mic3.jpg'),
        require('@/assets/images/mic4.jpg'),
        require('@/assets/images/mic5.jpg'),
        require('@/assets/images/mic6.jpg'),
        require('@/assets/images/mic7.jpg'),
        require('@/assets/images/mic8.jpg'),
        require('@/assets/images/mic9.jpg'),
        require('@/assets/images/mic10.jpg'),
        require('@/assets/images/mic11.jpg'),
        require('@/assets/images/mic12.jpg'),
        require('@/assets/images/mic13.jpg'),
        require('@/assets/images/mic14.jpg'),
        require('@/assets/images/mic15.jpg'),
        require('@/assets/images/mic16.jpg'),
      ],
    }
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-align: center;
}

.background-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.image-wrapper {
  width: 100%;
  height: auto; /* 允许高度根据图片比例自动调整 */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 确保图片按比例缩放且完整展示 */
}

@media screen and (max-width: 768px) {
  .background-image {
    width: 100%;
    height: auto;
    object-fit: contain; /* 在小屏幕上按比例缩放 */
  }
}
</style>
